import React from "react";
import { motion } from "framer-motion";
import { fadeUp, staggerContainer, wdViewport } from "./WdMotion";
import { wdWordPressPlugins } from "../../data/websiteDevelopmentPageContent";

export const WdWordPressSection = () => (
    <section className="wd-section wd-wp">
        <div className="wd-container wd-wp__grid wd-layout--reverse">
            <div className="wd-wp__copy">
                <div className="wd-section-header">
                    <h2 className="wd-section-title">WordPress Website</h2>
                    <p className="wd-section-subtitle">
                        Flexible content management with{" "}
                        <span className="wd-accent">powerful plugins</span>
                    </p>
                </div>
                <p className="wd-section-desc">
                    Flexible and scalable WordPress solutions with custom themes, plugins, blog
                    management, SEO optimization, and easy content administration. Suitable for
                    growing businesses and content-driven websites.
                </p>
            </div>

            <div className="wd-wp__plugin-stage">
                <svg className="wd-wp__lines" viewBox="0 0 400 320" aria-hidden>
                    <motion.path
                        d="M200 160 L80 60 M200 160 L320 60 M200 160 L80 260 M200 160 L320 260"
                        fill="none"
                        stroke="url(#wpLineGrad)"
                        strokeWidth="1.5"
                        strokeDasharray="6 4"
                        initial={{ pathLength: 0, opacity: 0 }}
                        whileInView={{ pathLength: 1, opacity: 0.6 }}
                        viewport={wdViewport}
                        transition={{ duration: 1.2, ease: "easeOut" }}
                    />
                    <defs>
                        <linearGradient id="wpLineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#002454" />
                            <stop offset="100%" stopColor="#9e00ff" />
                        </linearGradient>
                    </defs>
                </svg>

                <motion.div
                    className="wd-wp__hub"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={wdViewport}
                    transition={{ duration: 0.5 }}
                >
                    WP
                </motion.div>

                <motion.div
                    className="wd-wp__cards"
                    initial="hidden"
                    whileInView="visible"
                    viewport={wdViewport}
                    variants={staggerContainer}
                >
                    {wdWordPressPlugins.map((plugin, i) => (
                        <motion.div
                            key={plugin.name}
                            className={`wd-wp__card wd-wp__card--${i}`}
                            variants={fadeUp}
                            custom={i * 0.08}
                        >
                            <div className="wd-wp__card-icon">
                                {plugin.name.charAt(0)}
                            </div>
                            <div>
                                <div className="wd-wp__card-name">{plugin.name}</div>
                                <div className="wd-wp__card-desc">{plugin.desc}</div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    </section>
);
